import { esImg as esImgPc } from "./imgMap";
import { ptImg as ptImgPc } from "./imgMap";
import { enImg as enImgPc } from "./imgMap";
import { cnImg as cnImgPc } from "./imgMap";
import { tcImg as tcImgPc } from "./imgMap";
import { thImg as thImgPc } from "./imgMap";
import { idImg as idImgPc } from "./imgMap";
// 西班牙语
let esImg = {}
// 葡萄牙语
let ptImg = {}
// 英语
let enImg = {}
// 简中
let cnImg = {}
// 繁中
let tcImg = {};
// 泰语
let thImg = {};
// 印尼语
let idImg = {};

const imgMap = {
  '--home-gift-title': 'home_gift_title.png',
  '--skin-detail-1': 'skin_detail_1.png',
  '--skin-detail-2': 'skin_detail_2.png',
  '--skin-detail-3': 'skin_detail_3.png',
  '--skin-detail-4': 'skin_detail_4.png',
  '--skin-detail-5': 'skin_detail_5.png',
  '--skin-detail-6': 'skin_detail_6.png',
  '--skin-detail-7': 'skin_detail_7.png',
}
Object.keys(imgMap).forEach((key) => {
  esImg[key] = `url('${
    new URL(`./es/m/${imgMap[key]}`, import.meta.url).href
  }')`;
  ptImg[key] = `url('${
    new URL(`./pt/m/${imgMap[key]}`, import.meta.url).href
  }')`;
  enImg[key] = `url('${
    new URL(`./en/m/${imgMap[key]}`, import.meta.url).href
  }')`;
  cnImg[key] = `url('${
    new URL(`./cn/m/${imgMap[key]}`, import.meta.url).href
  }')`;
  tcImg[key] = `url('${
    new URL(`./tc/m/${imgMap[key]}`, import.meta.url).href
  }')`;
  thImg[key] = `url('${
    new URL(`./th/m/${imgMap[key]}`, import.meta.url).href
  }')`;
  idImg[key] = `url('${
    new URL(`./id/m/${imgMap[key]}`, import.meta.url).href
  }')`;
})

esImg = Object.assign({}, esImgPc, esImg);
ptImg = Object.assign({}, ptImgPc, ptImg);
enImg = Object.assign({}, enImgPc, enImg);
cnImg = Object.assign({}, cnImgPc, cnImg);
tcImg = Object.assign({}, tcImgPc, tcImg);
thImg = Object.assign({}, thImgPc, thImg);
idImg = Object.assign({}, idImgPc, idImg);

export { enImg, ptImg, esImg, cnImg, tcImg, thImg, idImg }
